module.exports = __webpack_public_path__ + "static/kid5-ad4aa977f72c9bf3c7fc43086450d98f.jpg";